export default __webpack_public_path__ + "static/media/id-card-front.d77d0e06.jpg";